export default {
    published: "Published",
    draft: "Draft",
    scheduled: "Scheduled",
    expired: "Expired",
};
